var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card", { staticClass: "card", attrs: { flat: "" } }, [
    _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v(" Cancelar plano ")])
    ]),
    _c("div", { staticClass: "plano" }, [
      _c("span", [
        _c("span", { staticClass: "strong" }, [_vm._v("Plano")]),
        _vm._v(" Kristal "),
        _c(
          "span",
          { staticClass: "strong-2", style: { color: _vm.planInfo.color } },
          [_vm._v(_vm._s(_vm.planInfo.title))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }